/* eslint-disable react/prop-types */
import 'url-search-params-polyfill';

import React, { PureComponent } from 'react';
// import PropTypes from 'prop-types';
import { Button } from 'antd';
import {
  DownloadOutlined,
  RightOutlined,
  LeftOutlined,
} from '@ant-design/icons';
import { Document, Outline, Page } from 'react-pdf';
import axios from 'axios';
import { tomcatHost } from '../../../config/properties';

export default class DibbsPdfViewer extends PureComponent {
  // static propTypes = {
  //   data: PropTypes.object.isRequired,
  // };

  state = {
    numPages: 0,
    pageNumber: 1,
    xml: null,
  };

  async componentDidMount() {
    console.log(this.props.data.solNum);
    try {
      const xml = await axios.get(
        `${tomcatHost}/solicitations/pdf/solnum/${this.props.data.solNum}`,
        {
          responseType: 'arraybuffer',
        },
      );

      this.setState({ xml });
    } catch (error) {
      console.error(error);
    }

    // const { organizationId } = this.props.auth;
    // await this.getContractData(organizationId);
  }

  onDocumentLoadSuccess = async ({ numPages }) => {
    await this.setState({
      numPages,
    });
  };

  _onClick = () => {
    const href = `${tomcatHost}/solicitations/pdf/solnum/${this.props.data.solNum
      }`;
    window.open(href, '_blank');
  };

  changePage = offset =>
    this.setState(prevState => ({
      pageNumber: prevState.pageNumber + offset,
    }));

  previousPage = () => this.changePage(-1);
  nextPage = () => this.changePage(1);

  render() {
    const { pageNumber, numPages } = this.state;
    return (
      <div>
        <Document
          file={this.state.xml}
          onLoadSuccess={this.onDocumentLoadSuccess}
        >
          <Outline />
          <Page pageNumber={pageNumber} />
        </Document>
        <div>
          <p>
            Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
          </p>
          <div className="help-button-container">
            <Button
              shape="circle"
              icon={<LeftOutlined />}
              disabled={pageNumber <= 1}
              onClick={this.previousPage}
            />
            <Button
              shape="circle"
              icon={<RightOutlined />}
              disabled={pageNumber >= numPages}
              onClick={this.nextPage}
            />
            <br />
            <Button
              primary
              shape="circle"
              icon={<DownloadOutlined />}
              onClick={this._onClick}
            // title={[nFile]}
            />
          </div>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/subcomponents/DibbsPdfViewer.jsx